export const CONTENT_ITEM_INPUT_ID_MAX_LENGTH = 256;
